import React from 'react';
import styles from './SelectTemplateModal.scss';
import { SelectTemplateTable } from './SelectTemplateTable';
import { Button } from '@/Components/Controls/Button/Button';
import { BUTTON_THEMES } from '@/Components/Controls/Button/ButtonThemes';
import { Modal } from '@/Components/Modal/Modal';
import { useLocalization } from '@/Hooks';
import { useSelectTemplateOptions } from './hooks/useSelectTemplateOptions';
import { useSelectTemplateModal } from './hooks/useSelectTemplateModal';
import { ButtonsWrapper } from '@/Components/Forms/ButtonsSection/ButtonsSection';

type Props = {
  onClose: () => void;
};

export const SelectTemplateModal = ({ onClose }: Props) => {
  const {
    modalWindows: { emailSendModal },
    buttons,
  } = useLocalization();

  const { sendEmail } = useSelectTemplateModal();
  const { isCreatingDisabled } = useSelectTemplateOptions();

  return (
    <Modal
      onClose={onClose}
      className={styles.modal}
      tourKey={'emailSendTour'}
      modalId={'selectTemplateModal'}
      description={{
        title: emailSendModal.Title,
      }}
    >
      <SelectTemplateTable />

      <ButtonsWrapper>
        <Button text={buttons.Cancel} theme={BUTTON_THEMES.SUCCESS_TRANSPARENT} onClick={onClose} />
        <Button
          autoFocus={true}
          text={buttons.Send}
          theme={BUTTON_THEMES.SUCCESS}
          disabled={isCreatingDisabled}
          onClick={sendEmail}
        />
      </ButtonsWrapper>
    </Modal>
  );
};
